import React, {useState, useEffect} from 'react'
import styled, { keyframes } from 'styled-components';
import { fetchWrapper } from '../../utils/apiHandlers';
import { RiArrowRightSLine } from 'react-icons/ri';
import Button from '../Button';
import SmallButton from '../SmallButton';
import TextboxComp from '../TextboxComp';
import MessageModal from '../MessageModal';
import HorizontalLine from '../horizontalLine';
import ConfirmModal from '../ConfirmModal';
import { MdEdit, MdCancel } from "react-icons/md";
import EditQAModal from '../EditQAModal';

interface Prop{
  userid: string;
}
const TrainerComp : React.FC<Prop>=({userid})=>{

  const [ trainer, settrainer ] = useState<any>([])
  const [ answerupdated, setanswerupdated ] = useState(false)
  const [ confirmmodalstate, setconfirmmodalstate ] = useState(false)
  
  const [ modalstate, setmodalstate ] = useState(false)
  const [ modalheader, setmodalheader ] = useState("")
  const [ modalmessage, setmodalmessage ] = useState("")
  const [ modalprogress, setmodalprogress ] = useState(false)
  const [ question, setquestion ] = useState("")
  const [ answer, setanswer ] = useState("")

  const [ deleteid, setdeleteid ] = useState(-1)

  const [ selecteditem, setselecteditem ] = useState(null)
  const [ selecteditemid, setselecteditemid ] = useState(-1)
  
  const [ editmodalstate, seteditmodalstate ] = useState(false)
  const [ startid, setstartid ] = useState(0)
  
  const getLast50Trainer = async () => {
    if(startid>0 && trainer.length<100)return
    openModal("Loading trainer data", "", true)

    let response = await fetchWrapper.post("/api/analysis/getlast50trainer", {userid: userid, start: startid}).then(r=>r)
    settrainer(response.trainer)    
    setmodalstate(false)
    setstartid(response.start+100)
    // openModal("Loading trainer data", "", true)
  }

  const getTrainer = async () => {
    if(startid>0 && trainer.length<100)return
    openModal("Loading trainer data", "", true)

    let response = await fetchWrapper.post("/api/analysis/gettrainer", {userid: userid, start: startid}).then(r=>r)
    settrainer(response.trainer)    
    setmodalstate(false)
    setstartid(startid+100)
    // openModal("Loading trainer data", "", true)
  }
  const getPrevTrainer = async () => {
    if(startid-200<0)return
    openModal("Loading trainer data", "", true)

    let response = await fetchWrapper.post("/api/analysis/gettrainer", {userid: userid, start: startid-200}).then(r=>r)
    settrainer(response.trainer)    
    setmodalstate(false)
    setstartid(startid-100)
    // openModal("Loading trainer data", "", true)
  }


  const updateitem = async (id: any, q: any, a: any) =>{
    openModal("Updating answer", "", true)
    let response = await fetchWrapper.post("/api/analysis/updatetrainer", {userid: userid, question:q, answer: a, id:trainer[id]._id}).then(r=>r)
    seteditmodalstate(false)
    openModal("Answer updated", "done!", false)
  }

  const deleteanswerPrompt = async (id: any) =>{
    setdeleteid(id)
    setmodalheader("Deleting data")
    setmodalmessage(`Are  you sure you want to delete data?\n${trainer[id].question}`)
    setconfirmmodalstate(true)
  }

  const deleteanswer = async () =>{
    setconfirmmodalstate(false)
    openModal("Deleting data", "", true)
    let response = await fetchWrapper.post("/api/analysis/deletetrainer", {id:trainer[deleteid]._id}).then(r=>r)
    await getTrainer()
    seteditmodalstate(false)
    openModal("Data deleted", "done!", false)
  }

  const openModal = (header: any, message: any, progress?: any) => {
    setmodalheader(header)
    setmodalmessage(message)
    progress?setmodalprogress(true): setmodalprogress(false)
    setmodalstate(true)
  }

  const changenewquestion = (e: any) =>{
    
    if(e.length>256)return
    setquestion(e.target.value)
  }
  const changenewanswer = (e: any) =>{
    if(e.length>256)return
    setanswer(e.target.value)
  }

  const addnewtrainer  = async () => {
    if(question=="" || answer==""){
      openModal("Warning", "Please enter question and answer to update training data.", false)
      return
    }

    try{
      openModal("Adding data", "", true)
      let response = await fetchWrapper.post("/api/analysis/insertintotrainer", {userid: userid, question: question, answer: answer, }).then(r=>r)
      setquestion("")
      setanswer("")
      await getLast50Trainer()
      openModal("Data added", response.msg, false)
    }catch(error){
      openModal("Error", "Something unexpected happened please try again later or contact support@miamigo.ai", false)
    }

  }

  const edititem = (id: any) => {
    setselecteditem(trainer[id])
    setselecteditemid(id)
    seteditmodalstate(true)
  }

  useEffect(()=>{
    setstartid(0)
  }, [])
  

  return(
    <MainContainer>
      <EditQAModal 
        item={selecteditem} state={editmodalstate} handleClose={()=>seteditmodalstate(false)} update={updateitem} deleteitem={deleteanswerPrompt} itemid={selecteditemid}
      />
      <MessageModal state={modalstate} header={modalheader} message={modalmessage} progress={modalprogress} handleClose={()=>setmodalstate(false)} />
      <ConfirmModal 
        header={modalheader} message={modalmessage} state={confirmmodalstate} handleClose={()=>setconfirmmodalstate(false)} func={()=>deleteanswer()} />
      <Column style={{backgroundColor:editmodalstate?"#000":""}}>
        <SubHeader>Add Training data</SubHeader>
        <Item ><TextboxComp key={`tb_key_${-999}`} id={`tb_id_${-999}`} value={question} onChange={(e: any)=>{changenewquestion(e)}} rows={5} cols={50} height={100} placeholder='question' /></Item>

        <Item ><TextboxComp key={`tb_key_${-999}`} id={`tb_id_${-999}`} value={answer} onChange={(e: any)=>{changenewanswer(e)}} rows={5} cols={50} height={100} placeholder='answer' /></Item>
        <Item style={{flex:0.15}}><SmallButton text="Insert" handleClick={(e)=>{addnewtrainer()}} /> </Item>
        <HorizontalLine />

        <SubHeader>Training Data</SubHeader>
        {startid==0?
          <Button text='load' handleClick={()=>getTrainer()} />
          :
          <ButtonContainer>
            <Button text='Prev' handleClick={()=>getPrevTrainer()} />
            <Button text='Next' handleClick={()=>getTrainer()} />

          </ButtonContainer>
        }

        {
          trainer&&trainer.length>0?
          trainer.map((v:any, k: any) => (

              <QAColumn style={{width: "100%"}} key={`trainer_key_${startid+k}`}>
              <QuestionContainer >
                  
                  <Question>
                    {startid+k-99}&#41;&nbsp;{v.question}
                    <MdEdit color={"black"} onClick={()=>edititem(k)} />
                  </Question>

              </QuestionContainer>
              <AnswerContainer>
                <Answer>
                      {v.answer}
                </Answer>
              </AnswerContainer>
              </QAColumn>
            ))
          
          :<></>
        }

        {/* <Button text='load' handleClick={()=>getTrainer()} /> */}
      </Column>
      <br/>
      <br/>
      <br/>
    </MainContainer>
  );
}

const showAnimation = keyframes`
0% {
    opacity: 0
  }
  50% {
    opacity: 0.5
  }
  100% {
    opacity: 1;
  }
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(90deg);
  }
}`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  align-items: center;
  width: 100%;
`

const RowHead = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin: 0px;
  padding: 3px;
  border-bottom: 1px solid black;
  @media (max-width: 770px) {
    flex-direction: column;
  }
`

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  margin: 0px;
  padding: 3px;
  border-bottom: 1px solid black;
  @media (max-width: 770px) {
    flex-direction: column;
  }&:hover{
    background-color: #eee;
  }
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  color: #000;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  @media (max-width: 770px) {
    padding: 20px 50px;
  }
`
const QAColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  color: #000;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  z-index: 1;
  padding: 20px;
    @media (max-width: 770px) {
  }
`

const Header = styled.div`
    padding: 10px;
    font-weight: 700;
    font-size: 40px;
    justify-content: flex-end;
    color: black;
`;

const SubHeader = styled.div`
    padding: 10px;
    font-weight: 700;
    font-size: 30px;
    justify-content: flex-end;
    color: black;
`;

const Item = styled.div`
    justify-content: flex-start;
    align-items: flex-start;
    padding: 0;
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    color: black;
`;

const QuestionContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    color: black;
    animation: ${showAnimation} 0.5s linear;
    width: 100%;
`;

const AnswerContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    color: black;
    width: 100%;
`;

const Question = styled.span`
    // display: flex;
    width: 100%;
    font-weight: 400;
    font-size: 18px;
    justify-content: flex-end;
    color: black;
    cursor: pointer;

`;
const Answer = styled.div`
    margin: 10px 0 0 0;
    font-weight: 400;
    font-size: 15px;
    justify-content: flex-end;
    line-height: 2;
    color: black;
`;

const ButtonContainer = styled.div`
  display: flex;
`;

export default TrainerComp

